import { z } from "zod";
import { Id, Timestamp } from "./common.js";

/** Attachments (spec05). The upload itself is multipart with one `file` part. */

export const AttachmentParams = z.object({ id: Id });

export const Attachment = z.object({
  id: Id,
  name: z.string(),
  /** Detected from the content, not the name. */
  mimeType: z.string(),
  size: z.number().int().nonnegative(),
  /** FR2: shown inline (PNG, JPEG, GIF, WebP) or download only. */
  inline: z.boolean(),
  /** The URL notes link to. */
  url: z.string(),
  createdAt: Timestamp,
});
export type Attachment = z.infer<typeof Attachment>;

export const AttachmentUsage = z.object({
  bytes: z.number().int().nonnegative(),
  count: z.number().int().nonnegative(),
  quotaBytes: z.number().int().nonnegative(),
});
export type AttachmentUsage = z.infer<typeof AttachmentUsage>;

export const DeletedAttachments = z.object({
  count: z.number().int().nonnegative(),
  bytes: z.number().int().nonnegative(),
});
export type DeletedAttachments = z.infer<typeof DeletedAttachments>;
